import { http } from '@/utils/http';
import qs from 'qs';

const BASEURL = '/vote/2020project/2020hps/controller.php?enews=';

export const getBaseInfo = () => {
  return http.get(`${BASEURL}base-info`);
};

export const getRules = () => {
  return http.get(`${BASEURL}rules`);
};
export const getEnlistTime = () => {
  return http.get(`${BASEURL}enlist-time`);
};

// 投票列表页
export function getlist(
  voteName: string,
  page?: number,
  type?: any,
  search?: any,
) {
  return http.get(
    '/vote/' +
      voteName +
      '/controller.php?enews=vote-list&type=' +
      type +
      '&page=' +
      page +
      '&search=' +
      search,
  );
}

export const getDetail = (id: any) => {
  return http.get(`${BASEURL}detail`, {
    params: { id },
  });
};

interface ISAve {
  type: any;
  udid: any;
  appkey: any;
}
export const isSave = (data: ISAve) => {
  return http.post(`${BASEURL}is-save`, qs.stringify(data));
};
